
/**
 * url处理类
 * @author kyomic
 */
let urls = {

}

urls.toParams = function (obj) {
  var arr = [];
  for (var i in obj) {
    arr.push(i + "=" + arr[i]);
  }
  return arr.join("&");
}
/**
 * 生成URL地址和参数格式,如{url, params}
 */
urls.parseURL = function (url) {
  if (!url) {
    debugger;
  }
  var urls = url.split("?");
  var paramstr = "";
  if (urls.length > 1) {
    paramstr = urls[1]
  }
  url = urls[0];
  var arr = paramstr.split("&");
  var params = {};
  for (var i = 0; i < arr.length; i++) {
    var s = arr[i].split("=");
    if (s && s[0]) {
      var v = '';
      try {
        v = decodeURIComponent(s[1])
      } catch (e) {
        v = s[1];
      }
      params[s[0]] = s[1];
    }
  }
  return {
    url: url, params: params
  }
}
urls.concatURL = function (url, params) {
  var arr = [];
  for (var i in params) {
    arr.push(i + "=" + params[i]);
  }
  if (url.indexOf("?") == -1) {
    return url + "?" + arr.join("&");
  }
  return url + "&" + arr.join("&");
};
urls.addURLParams = function (url, params) {
  if (params) {
    var info = urls.parseURL(url);
    params = params || {};
    var newparams = Object.assign(Object.assign({}, info.params), params);
    return urls.concatURL(info.url, newparams);
  } else {
    return url;
  }

};

/**
 * 将目标字符串中可能会影响正则表达式构造的字符串进行转义。
 * @name escapeReg
 * @function
 * @grammar escapeReg(source)
 * @param {string} source 目标字符串
 * @remark
 * 给以下字符前加上“\”进行转义：.*+?^=!:${}()|[]/\
 * @meta standard
 *
 * @returns {string} 转义后的字符串
 */
function escapeReg (source) {
  return String(source).replace(new RegExp('([.*+?^=!:\x24{}()|[\\]\/\\\\])', 'g'), '\\\x241');
}
urls.getQueryValue = function (key, url) {
  var reg = new RegExp('(^|&|\\?|#)' + escapeReg(key) + '=([^&#]*)', 'g');
  var match = (url || window.location.href).match(reg);
  if (match) {
    return match[match.length - 1].split('=')[1];
  }
  return null;
};

urls.queryParams = function (url) {
  url = url;
  if (url.indexOf("?")) {
    url = url.substring(url.indexOf("?") + 1);
    var arr = url.split("&");
    var res = {};
    for (var i = 0; i < arr.length; i++) {
      var u = (arr[i] || "").split("=");
      if (u && u[0]) {
        var v = "";
        try {
          v = decodeURIComponent(u[1])
        } catch (e) { }
        if (v == "undefined") v = "";
        res[u[0]] = v;
      }
    }
    return res;
  }
  return {};
}
urls.addParam = function (url, queryObj) {
  if (!queryObj) return url;
  var array = [];
  for (var key in queryObj) {
    if (this.hasParam(url, key)) {
      this.removeParam(key);
    }
    array.push(key + '=' + queryObj[key]);
  }
  return (url + '&' + array.join('&')).replace(/[&?]{1,2}/, '?')
}
urls.removeParam = function (query, params) {
  if (!query || !params) return query;
  var type = {}.toString.call(params).toLowerCase();
  if (type.indexOf('array') > -1) params = params.join("|");

  return query.replace(new RegExp("(" + params + ")=([^&]+)", "g"), "")
    .replace(/(\?&+)/g, "?").replace(/(&+|\?)$/g, "").replace(/($)+/g, '$1');
}

urls.hasParam = function (url, param) {
  var params = this.getQuery(url).split('&');
  if (params) {
    for (var i = 0; i < params.length; i++) {
      var pair = params[i].split('=');
      if (decodeURIComponent(pair[0]) == param)
        return true;
    }
  }
  return false;
}
urls.getPath = function (url) {
  var pathexp = /(?:\/([^?]*))/;
  var match = pathexp.exec(url);
  if (match != null && match.length > 1) {
    return match[1];
  }
  return "";
}
urls.getQuery = function (url) {
  if (~url.indexOf('#')) {
    url = url.substr(0, url.indexOf("#"));
  }

  if (~url.indexOf('?')) {
    return url.substr(url.indexOf("?") + 1);
  }
  return '';
}

export default urls;
export {
  urls
}



// WEBPACK FOOTER //
// ./src/assets/js/urls.js